import {useLocation} from "@tanstack/react-router";
import {useEffect} from "react";

export default function OutbrainPixel() {
    const location = useLocation();

    useEffect(() => {
        if (window.location.hash === '#no-tracking') {
            return;
        }

        // Outbrain Pixel code (replace with your actual code)
        const script = document.createElement('script');
        script.setAttribute('data-obct', '');
        script.setAttribute('type', 'text/javascript');
        script.innerHTML = `
          /** DO NOT MODIFY THIS CODE**/
          !function(_window, _document) {
            var OB_ADV_ID = '00b5c0bbfcd93ef7d7a7ca341fd62f6a71';
            if (_window.obApi) {
              var toArray = function(object) {
                return Object.prototype.toString.call(object) === '[object Array]' ? object : [object];
              };
              _window.obApi.marketerId = toArray(_window.obApi.marketerId).concat(toArray(OB_ADV_ID));
              return;
            }
            var api = _window.obApi = function() {
              api.dispatch ? api.dispatch.apply(api, arguments) : api.queue.push(arguments);
            };
            api.version = '1.1';
            api.loaded = true;
            api.marketerId = OB_ADV_ID;
            api.queue = [];
            var tag = _document.createElement('script');
            tag.async = true;
            tag.src = '//amplify.outbrain.com/cp/obtp.js';
            tag.type = 'text/javascript';
            var script = _document.getElementsByTagName('script')[0];
            script.parentNode.insertBefore(tag, script);
          }(window, document);
          obApi('track', 'PAGE_VIEW');
    `;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    useEffect(() => {
        if (typeof window['obApi'] === 'function') {
            window['obApi']('track', 'PAGE_VIEW')
        }
    }, [location.href]);

    return null;
}
